var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pass",class:_vm.passed ? 'pass-success' : 'pass-fail'},[_c('div',{staticClass:"pass-content"},[_c('p',{staticClass:"pass-content-score"},[_vm._v(_vm._s(_vm.score)),_c('span',{staticClass:"text-normal"},[_vm._v("分")])]),_c('p',[_vm._v(_vm._s(_vm.passed ? '考试通过' : '考试未通过'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }